export const countElementsInGroup = (consents: any[], group: number): number => {
  return consents.filter((consent) => consent.group === group).length;
};
